import { Fragment, useEffect, useState } from 'react';
import { setOnlyNumbers, setPhoneNumber } from '../../utils/validationUtils';
import { FREE_TRIAL_VOUCHER_ALIMTALK_MESSAGE } from '../../network/Endpoint';
import Modal from '../../shared/components/Modal';
import { ReactComponent as OnepromathLogo } from '../../resources/images/logo2.svg';

const OnepromathApplicationModal = ({ showApplicationModal, closeApplicationModal, parentFormData, parentUsagePeriodParam, openApplicationResultModal, randomCountUp }) => {
  const [formData, setFormData] = useState({
    phoneNumber: '',
    usagePeriod: '',
    applicationType: '',
    code: '',
  });

  const setMessage = (code, phoneNumber, lastApplicationDate, remainingDays, availableDate, serverMessage) => {
    return (
      <div>
        {code === 'M0001' ? (<div>
          카카오톡 메시지로 1개월 체험권 발송이 완료되었습니다.
          <br/>
          <br/>
          카카오톡 메시지를 확인해 주세요.
        </div>) : code === 'M0004' ? (<div>
          유효하지 않은 전화번호에요. 전화번호를 다시 확인해 주세요.
        </div>) : code === 'M0005' ? (<div>
          [ErrorCode: M0005] 고객센터로 문의해 주세요.
        </div>) : code === 'M0007' ? (<div>
          <div>
            <span className={'text-[#00c400]'}>{setPhoneNumber(setOnlyNumbers(phoneNumber))}</span> 전화번호는 <span className={'text-[#00c400]'}>{lastApplicationDate}</span>에 신청하셔서
            {remainingDays === 0 ? (<Fragment> <span className={'text-[#00c400]'}>내일</span>부터 </Fragment>) : (<Fragment> <span
              className={'text-[#00c400]'}>{remainingDays}</span>일 뒤부터 </Fragment>)}신청이 가능해요.
            <br/>
            <br/>
            따라서, <span className={'text-[#00c400]'}>{availableDate}</span>부터 다시 신청해 주시길 바랍니다.
            <br/>
            <br/>
            감사합니다.
          </div>
        </div>) : code === 'M0006' ? (<div>
          [ErrorCode: M0006] 고객센터로 문의해 주세요.
        </div>) : code === 'M0008' ? (<div>
          [ErrorCode: M0008] 고객센터로 문의해 주세요.
        </div>) : code === 'M1103' ? (<div>
          이용권 신청이 마감되었어요.
          <br/>
          자세한 내용은 고객센터로 문의해 주세요.
        </div>) : code === 'M0012' || code === 'M0013' ? (<div>
          {serverMessage}
        </div>) : null}
      </div>
    );
  };

  const submit = async () => {
    const body = {
      brandName: 'ONEPROMATH',
      phoneNumber: setOnlyNumbers(formData.phoneNumber),
      usagePeriod: parseInt(formData.usagePeriod),
      applicationType: formData.applicationType,
      code: formData.code,
    };
    await FREE_TRIAL_VOUCHER_ALIMTALK_MESSAGE(body)
      .then(async (res) => {
        let message;
        if (res.data.statusResponse.code === 'M0001') { // 성공
          message = setMessage(res.data.statusResponse.code);
          await randomCountUp();
        } else if (res.data.statusResponse.code === 'M0004') { // 유효하지 않은 전화번호
          message = setMessage(res.data.statusResponse.code);
        } else if (res.data.statusResponse.code === 'M0005') { // 찾을 수 없는 브랜드
          message = setMessage(res.data.statusResponse.code);
        } else if (res.data.statusResponse.code === 'M0007') { // 이용 내역이 있음
          message = setMessage(res.data.statusResponse.code, setPhoneNumber(setOnlyNumbers(formData.phoneNumber)), res.data.lastApplicationDate, res.data.remainingDays, res.data.availableDate);
        } else if (res.data.statusResponse.code === 'M0006') { // 찾을 수 없는 템플릿
          message = setMessage(res.data.statusResponse.code);
        } else if (res.data.statusResponse.code === 'M0008') { // 찾을 수 없는 상품
          message = setMessage(res.data.statusResponse.code);
        } else if (res.data.statusResponse.code === 'M1103') { // 찾을 수 없는 이용권
          message = setMessage(res.data.statusResponse.code);
        } else if (res.data.statusResponse.code === 'M0012' || res.data.statusResponse.code === 'M0013') { // 비활성화된 인플루언서/광고
          message = setMessage(res.data.statusResponse.code, null, null, null, null, res.data.statusResponse.message);
        }
        closeApplicationModal();
        openApplicationResultModal(message);
      });
  };

  useEffect(() => {
    if (showApplicationModal) {
      setFormData({
        phoneNumber: parentFormData.phoneNumber,
        usagePeriod: parentUsagePeriodParam,
        applicationType: parentFormData.applicationType,
        code: parentFormData.code,
      });
    }
  }, [showApplicationModal]);

  return (
    <Modal show={showApplicationModal} closeModal={closeApplicationModal}>
      <div className={'max-w-[300px]'}>
        <div className={'flex justify-center'}>
          <OnepromathLogo className="w-[72px]"/>
        </div>
        <div className={'font-[nanum-square-b] mt-[20px]'}>
          고객님이 입력하신 연락처는
          <br/>
          [{setPhoneNumber(setOnlyNumbers(formData.phoneNumber))}]입니다!
          <br/>
          입력하신 연락처가 맞으시다면 아래 확인 버튼을 눌러 주세요. 잘못 입력하셨다면 X 버튼을 눌러 다시 작성해 주세요.
        </div>
        <div className={'mt-[20px]'}>
          <button type={'button'} onClick={submit} className={'border border-[#4e69f7] bg-[#4e69f7] text-[#ffffff] font-[nanum-square-round-eb] text-[24px] w-full h-[60px] rounded-[10px]'}>확인</button>
        </div>
      </div>
    </Modal>
  );
};

export default OnepromathApplicationModal;
